module.exports = __webpack_public_path__ + "static/media/flow-jump-mobile-es.ef04699c.png";